import * as React from 'react';
import { Route, Switch } from 'react-router';

import { EstimatesPageContainer } from './estimates-page/estimates-page';
import { TermsContainer } from './terms/terms';
import { ErrorPage } from 'src/core/components/error-page/error-page';
import { PrivateRoute } from 'src/routes';
import { ConfirmationPageContainer } from './confirmation-page/confirmation-page';
import { ApplicationContainer } from './service-finance/mobile/application-container';
import '@servicetitan/design-system/dist/system.min.css';

export interface RouteParams {
    bundleId: string;
    estimateId?: string;
}

export const EstimateRoutes: React.SFC = () => (
    <Switch>
        <Route
            exact
            path="/estimate/expired-link"
            component={() => <ErrorPage type="expired-link" />}
        />
        <PrivateRoute
            allowAnonEstimates
            allowAnonVisitAction
            exact
            path="/estimate/:bundleId"
            component={EstimatesPageContainer}
        />
        <PrivateRoute
            allowAnonEstimates
            allowAnonVisitAction
            exact
            path="/estimate/:bundleId/:estimateId"
            component={EstimatesPageContainer}
        />
        <PrivateRoute
            allowAnonEstimates
            allowAnonVisitAction
            exact
            path="/estimate/:bundleId/:estimateId/terms"
            component={TermsContainer}
        />
        <PrivateRoute
            allowAnonEstimates
            allowAnonVisitAction
            exact
            path="/estimate/:bundleId/:estimateId/confirm"
            component={ConfirmationPageContainer}
        />
        <PrivateRoute
            allowAnonEstimates
            allowAnonVisitAction
            exact
            path="/estimate/:bundleId/:estimateId/mobile"
            component={ApplicationContainer}
        />

        <Route component={() => <ErrorPage type="not-found" />} />
    </Switch>
);
